/****************************************************************************************
 * File Name    : SheetPatrol.vue
 * Function     :
 * Author       : 최명호
 * Tester       :
 * Page         :
 * Target       :
 * Description  :
 * Modification Log
 * ======================================================================================
 * Ver  Date        	Author     	Modification
 * ======================================================================================
   1.0  2021.04.16  	최명호    	Create
****************************************************************************************/
<template>
    <div>
        <a-row :gutter="16">
            <a-col class="gutter-row" :span="12">
                <div class="gutter-box">
                    <PageHeader title = "등록하기" />
                </div>
            </a-col>
        </a-row>
        <a-form class="" :form="form" layout = "vertical"  @submit="onSubmit">
            <a-card>
                <a-form-item label="모델명">
                    <a-input placeholder="" v-decorator="['model',{initialValue: model, rules: [{ required: true, message: '모델명을 입력하세요' }],},] "/>
                </a-form-item>
                <a-form-item label="부품명">
                    <a-input placeholder="" v-decorator="['part',{initialValue: part, rules: [{ required: true, message: '부품명을 입력하세요' }],},] "/>
                </a-form-item>
                <a-form-item label="변경목적">
                    <a-input placeholder="" v-decorator="['purpose',{initialValue: purpose, rules: [{ required: true, message: '변경목적을 입력하세요' }],},] "/>
                </a-form-item>
                <a-form-item label="변경내용">
                    <a-textarea placeholder="" rows="5" v-decorator="['content',{initialValue: content, rules: [{ required: true, message: '변경내용을 입력하세요' }],},] "/>
                </a-form-item>
                <a-form-item label="참고사진">
                    <div v-if="imgSrc.length">
                        <span v-for="(item) in imgSrc" :key="item.seq" style="margin-right:20px;">
                            <img :src = "item.src" style="max-width:200px;">
                            <span @click="deleteImg(item.seq);" style="cursor:pointer; vertical-align:bottom;">X</span>
                        </span>
                    </div>
                    <a-spin :spinning="spinning">
                        <a-upload name="file" :multiple="false" :action="$store.state.imageUploadServer" @change="imageUpload"
                            v-decorator="['photo',{rules: [{ required: false, message: '사진을 선택하세요' }],},]">
                            <a-button> <a-icon type="camera" /> 사진 선택 </a-button>
                        </a-upload>
                    </a-spin>
                </a-form-item>
                <a-form-item label="태블릿 표시">
                    <input type="checkbox" v-model="tablet" value="Y" />
                </a-form-item>
                <a-form-item label="공지시작일">
                    <date-picker v-model="start" valueType="format"></date-picker>
                </a-form-item>
                <a-form-item label="공지종료일">
                    <date-picker v-model="end" valueType="format"></date-picker>
                </a-form-item>
                <a-form-item label="입고 품질 담당자">
                    <a-input placeholder="" v-decorator="['qualityManager',{initialValue: qualityManager, rules: [{ required: false, message: '입고 품질 담당자를 입력하세요' }],},] "/>
                </a-form-item>
                <a-form-item label="ECO No">
                    <a-input placeholder="" v-decorator="['ecoNo',{initialValue: ecoNo, rules: [{ required: false, message: 'ECO No를 입력하세요' }],},] "/>
                </a-form-item>
                <a-form-item label="적용 초품 S/N">
                    <a-input placeholder="" v-decorator="['sn',{initialValue: sn, rules: [{ required: false, message: '적용 초품 S/N를 입력하세요' }],},] "/>
                </a-form-item>
                <a-form-item label="납품 업체명">
                    <a-input placeholder="" v-decorator="['supplier',{initialValue: supplier, rules: [{ required: false, message: '납품 업체명을 입력하세요' }],},] "/>
                </a-form-item>
                <a-form-item label="적용 예상 일정">
                    <date-picker v-model="expected" valueType="format"></date-picker>
                </a-form-item>
            </a-card>
            <p/>
            <a-button type="primary" html-type="submit" :ghost = false size = "default" icon = "plus-circle">저장</a-button>
            <a-divider type = 'vertical' />
            <a-button type="danger" html-type="reset" :ghost = false  size = "default" icon = "reload">초기화</a-button>
        </a-form>
    </div>
</template>
<script>
import _ from "lodash";
import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';
import PageHeader from "../components/PageHeader.vue";
export default {
    name: 'Patrol4m',
    components: {
        PageHeader ,
        DatePicker, 
    },
    data() {
        return {
            isDataLoaded : false,
            flagForDrawer: false,
            fileUploadSeq : '',
            spinning : false,
            image: null,
            model: null,
            part: null,
            purpose: null,
            content: null,
            photo: null,
            tablet: null,
            start: null,
            end: null,
            qualityManager: null,
            ecoNo: null,
            sn: null,
            supplier: null,
            expected: null,
            imgSrc: [],
            fileDelimiter: '||',
        };
    },
    beforeCreate() {
        this.form = this.$form.createForm(this, { name: 'validate_other' });
    },
    mounted() {
        if (this.$route.query.seq) {
            let url = this.$store.state.nodeApiUrl + '/patrol/4mitem/' + this.$route.query.seq;
            this.$http.get(url)
                .then((response) => {
                    console.log(response.data);
                    let item = response.data;

                    this.model = item.MODEL;
                    this.part = item.PART;
                    this.purpose = item.PURPOSE;
                    this.content = item.CONTENT;
                    this.tablet = item.TABLET === 'Y' ? true : false;
                    this.start = item.START;
                    this.end = item.END;
                    this.qualityManager = item.QUALITY_MANAGER;
                    this.ecoNo = item.ECO_NO;
                    this.sn = item.SN;
                    this.supplier = item.SUPPLIER;
                    this.expected = item.EXPECTED;
                    this.fileUploadSeq = item.UPLOAD_FILE_SEQ;

                    let files = this.fileUploadSeq.split(this.fileDelimiter);
                    _.forEach(files, (seq) => {
                        if (seq) {
                            this.imgSrc.push({
                                seq: seq,
                                src: this.$store.state.hostInService +'/upload/image/download/' + seq
                            });
                        }
                    });
                })
                .catch(error => {
                    console.log(error);
                });
        }
    },
    methods : {
        deleteImg(seq) {
            if (confirm('선택한 이미지를 삭제하시겠습니까?')) {
                let files = this.fileUploadSeq.split(this.fileDelimiter);
                files = _.reject(files, (item) => {
                    return item == seq;
                });
                this.fileUploadSeq = files.join(this.fileDelimiter);

                this.imgSrc = [];
                _.forEach(files, (seq) => {
                    if (seq) {
                        this.imgSrc.push({
                            seq: seq,
                            src: this.$store.state.hostInService +'/upload/image/download/' + seq
                        });
                    }
                });    
            }
        },
        onSubmit(e) {
            e.preventDefault();

            console.log(this.fileUploadSeq);

            this.form.validateFields((err, values) => {
                if(!err) {
                    if (this.$route.query.seq) {
                        let formData = {};
                        formData.model                = values.model;
                        formData.part              = values.part;
                        formData.purpose               = values.purpose;
                        formData.content          = values.content;
                        formData.tablet               = this.tablet ? 'Y' : 'N';
                        formData.start               = this.start;
                        formData.end                = this.end;
                        formData.quality_manager    = values.qualityManager;
                        formData.eco_no             = values.ecoNo;
                        formData.sn                 = values.sn;
                        formData.supplier           = values.supplier;
                        formData.expected           = this.expected;
                        formData.upload_file_seq     = this.fileUploadSeq;

                        let url = this.$store.state.nodeApiUrl + '/patrol/4mupdate/' + this.$route.query.seq;
                        this.$http.put(url,formData)
                            .then((response) => {
                                console.log(response);
                                this.$message.success('저장되었습니다');
                                location = '#/patrol4mList';
                            })
                            .catch(error => {
                                console.log(error);
                            });
                    } else {
                        let formData = {};
                        formData.model                = values.model;
                        formData.part              = values.part;
                        formData.purpose               = values.purpose;
                        formData.content          = values.content;
                        formData.tablet               = this.tablet ? 'Y' : 'N';
                        formData.start               = this.start;
                        formData.end                = this.end;
                        formData.quality_manager    = values.qualityManager;
                        formData.eco_no             = values.ecoNo;
                        formData.sn                 = values.sn;
                        formData.supplier           = values.supplier;
                        formData.expected           = this.expected;
                        formData.upload_file_seq     = this.fileUploadSeq;
                        
                        let url = this.$store.state.nodeApiUrl + '/patrol/4mcreate';
                        this.$http.post(url,formData)
                            .then((response) => {
                                console.log(response);
                                this.$message.success('저장되었습니다');
                                location = '#/patrol4mList';
                            })
                            .catch(error => {
                                console.log(error);
                            });
                        }
                    }
            });
        },
        imageUpload(info) {
            this.spinning = info.file.status === 'uploading' ? true : false;
            if(info.file.status === 'done') {
                let files = this.fileUploadSeq.split(this.fileDelimiter);
                files = _.filter(files, (seq) => {
                    return seq;
                });
                this.$message.success(`${info.file.name} file uploaded successfully`);
                files.push(info.file.response.data.uploadFileSeq);
                this.fileUploadSeq = files.join(this.fileDelimiter);
                
                // 이미지 리사이징 API 호출
                this.$http.post(`${this.$store.state.nodeApiUrl}/user/resize-image`, {
                    uploadFileSeq: info.file.response.data.uploadFileSeq
                })
                .then(response => {
                    if (response.data.code === 'success') {
                        console.log('✅ Image resized:', response.data.data);
                    }
                })
                .catch(error => {
                    console.error('❌ Resize failed:', error);
                });
            } else if(info.file.status === 'error') {
                this.$message.error(`${info.file.name} file upload failed.`);
            }
        }
    }
}
</script>
<style scoped>
</style>